
import { Component, Vue } from 'vue-property-decorator';
import { Module1Module } from '@/store/modules/module1';
import { AccountInfo } from '@airgap/beacon-sdk';

@Component
export default class Login extends Vue {
  signature = ''
  avatarImage = '';

  showModal = false;
  allowModalToBeClosed = false;
  modalTitle = 'Please Wait';
  modalParagraph = 'Transaction pending...'

  get account () : AccountInfo | undefined | null {
    return this.$store.state.module1.account;
  }

  possiblyCloseModal () : void {
    if (this.allowModalToBeClosed) {
      this.showModal = false;
      this.allowModalToBeClosed = false;
    }
  }

  async login () : Promise<void> {
    try {
      this.showModal = true;
      this.modalTitle = 'Logging In';
      this.modalParagraph = 'Please wait...';

      await Module1Module.Login();

      this.showModal = false;
      this.$router.push({
        name: 'Propose',
        path: '/propose'
      });
    } catch (error: any) {
      this.showModal = true;
      this.modalTitle = '<span class="text-red-600">Error: ' + error.title + '</span>';
      this.modalParagraph = error.description;

      if (!error.title && !error.description) {
        this.modalTitle = '<span class="text-red-600">Error</span>';
        this.modalParagraph = 'If this was unexpected please contact support';
      }

      this.allowModalToBeClosed = true;
      console.warn(error);
    }
  }
}
